import { IInputProps } from '../types';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const getInputKey = (input: IInputProps<any, any>) => {
  return input.name;
};
